import CryptoJS from 'crypto-js'
import jsrsasign from 'jsrsasign'

// Base64 URL 编码 → 标准 Base64
function base64UrlToBase64 (base64Url) {
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const padLength = (4 - (base64.length % 4)) % 4
  base64 += '='.repeat(padLength)
  return base64
}

function base64UrlEncodeFromBase64 (base64String) {
  // 1. 替换 '+' 为 '-'
  let urlSafeBase64 = base64String.replace(/\+/g, '-')

  // 2. 替换 '/' 为 '_'
  urlSafeBase64 = urlSafeBase64.replace(/\//g, '_')

  return urlSafeBase64
}

const clientPrivateKey = '-----BEGIN PRIVATE KEY-----\n' +
    base64UrlToBase64('MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCpLbm7EwIXDQp4Eq5E-XKvxasKvK6I5H642fwMBTxIseuOtLqIo46KaTaN0RaUBD2V_UQifELRRNpxH4qgBB_FTf5xJWsbiJPGTUODEgz2Ok5a9cnTUySnJCqS08UApOR2f-pVjLKhfFAGU57BQVi-3RwR4dfjJkQaLCxjAkerj5XTrjICHA0MVk16MpNyUVFvzWR9kKJ1W_Uhy6cADV0MdG900pgF30FFu5qn0VDelNptZMpdQA-5tDFkYle9uSSDjLCRjUSUqcwIRezenqr8Si-KrT05tlvWZhaq4N9mkD4f-fEDHpFIi3PcEl06y8mFm5LG_if6lfZ3_mucQV5BAgMBAAECggEAX3ydfgdGgLgtloQEtI2Ou8L3vUGtyToehDsU1bwGwIkbiRpcxk56X4ju77B56-VQ1V1znXtBQ1h3aq4A0jxBql1RJY-XGp1FuwFU_5-qjTdvjkt4NLySzXvOQ70fTjPDd1bPbqXRFPBTQp7j1fQKIQAvnbA4585rVdJk4yUgSqX6nlC3WBhvZ5VLH7UaNmNh74fSLVJOBMo7ZKRAzh2fOGeHFLRP4wrY-E3XylZnyQho0utw416-END8I_RqSg_oeMxC6KfsA_7yGQnml9TPCVQnhGG51i6XdM9HR1sk-Inq-uL9KWZfgC_Eb_VmYQSLJbKGsItHgyKioiaxwI7iWQKBgQD-a6CHJSUHma6XasJdx0ghak08Tv_La2FkjivU1k62nh6xa6AvtIKrNgZGV57Ec6IF3s5CqQo1ALSyfAOqOF5Iw1RfVapnAFT9385lM2ojLBbi6tiVKapgipHxuWm0UTZ7gIUyWMgeEmjdkYZo1LBzw5J6UOSuj33SY8pzf-aP4wKBgQCqOp24Fw8_XGSdu9Vn7i8nHXK_GkHA98oI7931qgaItoN6fMc97O-Y9cqPyg6vIubbu0fXkHI_xOwVTcT3JBa5-PcjrMlEj7OXf27-BCCs-hq9DkcjgKUkJZfZizNz-bBiWWBXiv1fjXPuAdaH4MOz66jPk_hII7LLY_Z8TZIqiwKBgQDJ7EW1vQdMpu5ognTM1RMsYh_2k4R0wD7F_ghPnd9PFOOrUI4MDqn-lJwaTARYSqX3HsR5J4xQUMUZO0_1U1ORUGWwXF8n7J2H-I7oxwuf6qgnZNiMWks83_3A6bU5RZOGJZSRRuFc7KOJ5qvUm6mH11pz9avp1zy3NDhDvukQnQKBgQCh8MVd_cHpmvG1BJ3OE08UPPWOS2JGOvQecGKNdERnBoopmk7I4IBG2XzsMWKqxd8tJgsATVACzklxMtyv58se_HPPom6OJM7KztY-HJshM4UAWXbflWCE9KZys_Qs3looFbKLVZQYtK6Wu3TlKrPCk-uyHahSqHNM_jncosbsZQKBgFE6ZbgtlwPHlhGgKSYWACYfgrP_dMXFYrMrwWasqJWaBf4SUDauGorWfzPeBCaLPCyolKxzEnesQhNjs_vl1GopUU4uhfi0FWevBvD-wAMeUKNtzxzXbiv55GDZlO_Ig61iNNJmvUnNvUfx9Xkb5IKbyEQhL4E9vKLiNRdLuhjH') +
    '\n-----END PRIVATE KEY-----'

// 将params对象转为queryString
const transferQueryString = (data) =>
  Object.keys(data)
    .sort()
    .map(key => `${key}=${data[key]}`)
    .join('&')

const signatureToBase64 = (queryStr) => {
  try {
    // 获取秘钥实例
    const { KEYUTIL, Signature } = jsrsasign
    const key = KEYUTIL.getKey(clientPrivateKey)

    // 创建签名对象,并设置签名算法
    const signature = new Signature({ alg: 'SHA1withRSA' })
    signature.init(key)

    // 对原始数据进行签名
    signature.updateString(queryStr)
    const signResult = signature.sign()

    // 将签名结果从十六进制转换为 Base64 编码
    return jsrsasign.hextob64(signResult)
  } catch (error) {
    // 如果签名过程中出现错误,抛出错误信息
    throw new Error(`签名数据时发生错误: ${error.message}`)
  }
}

export const handleGetRsaSign = (params) => {
  const queryStr = CryptoJS.MD5(transferQueryString(params)).toString() // 对body参数进行 ascII 排序后进行拼接，拼接格式 key1=value1&key2=value2
  return base64UrlEncodeFromBase64(signatureToBase64(queryStr)) // 进行 md5 加密后使用客户端私钥进行 rsa sign 签名
}
